<template>
  <el-dialog title="Produkt Instanz erstellen" :visible="show" @close="close"
    width="30%"
  >
    <div class="row">
      <div class="col-sm-12">
        <form @submit.prevent="submit">
          <fg-input label="Anzahl zu erstellender Instanzen"
            v-model="qty" type="number"
            :error="valErrors['qty'] ? valErrors['qty'][0] : null"
          />
          <div class="form-group has-label">
            <warehouse-select
              v-model="warehouse"
              :options="warehouses"
            />
          </div>
          <div class="d-flex justify-content-between">
            <button type="submit" class="btn btn-fill btn-primary"
              :disabled="!qty || !warehouse"
            >
              Erstellen
            </button>
            <button class="btn btn-fill btn-default"
              @click.prevent="close"
            >
              Abbrechen
            </button>
          </div>
        </form>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { Dialog } from 'element-ui'
import WarehouseSelect from 'src/components/warehouse-select.vue'

export default {
  props: ['show', 'valErrors'],
  components: { [Dialog.name]: Dialog, WarehouseSelect },
  data () {
    return {
      qty: 1,
      warehouses: [],
      warehouse: this.$store.state.filters.warehouse
    }
  },
  methods: {
    submit () {
      this.$emit('addInstance', { qty: this.qty, warehouse_id: this.warehouse.id })
    },
    close () {
      this.$emit('close')
      this.qty = 1
      this.warehouse = null
    }
  },
  created () {
    this.$http.get('/warehouses').then(({ data }) => { this.warehouses = data })
  }
}
</script>

<style>
</style>
